import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as sentry from "@sentry/browser";
import { getFacturaHistorico } from "../../../services/compra.services.js";
import { Stepper } from "@artprov/design-system";

export default function InvoiceHistory({ idComprobante, refreshKey = 0 }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getFacturaHistorico(idComprobante);
        const next = Array.isArray(data) ? data : (data && typeof data === "object" ? [data] : []);
        setItems(next);
      } catch (e) {
        sentry.captureException(e);
      }
    };
    if (idComprobante) fetchData();
  }, [idComprobante, refreshKey]);

  const parseFecha = (raw) => {
    const s = String(raw ?? "").trim();
    if (!s) return Number.POSITIVE_INFINITY;
    const isoLike = /^\d{4}-\d{2}-\d{2}/.test(s) || s.includes("T") || s.includes("Z");
    if (isoLike) {
      const t = Date.parse(s);
      return Number.isFinite(t) ? t : Number.POSITIVE_INFINITY;
    }
    const dmY = /^(\d{2})[/-](\d{2})[/-](\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(s);
    if (dmY) {
      const d = parseInt(dmY[1], 10);
      const m = parseInt(dmY[2], 10) - 1;
      const y = parseInt(dmY[3], 10);
      const hh = dmY[4] ? parseInt(dmY[4], 10) : 0;
      const mm = dmY[5] ? parseInt(dmY[5], 10) : 0;
      const ss = dmY[6] ? parseInt(dmY[6], 10) : 0;
      const date = new Date(y, m, d, hh, mm, ss);
      const t = date.getTime();
      return Number.isFinite(t) ? t : Number.POSITIVE_INFINITY;
    }
    const t = Date.parse(s);
    return Number.isFinite(t) ? t : Number.POSITIVE_INFINITY;
  };

  const sorted = [...items].sort((a, b) => {
    const ta = parseFecha(a?.FECHA);
    const tb = parseFecha(b?.FECHA);
    return ta - tb;
  });

  const steps = sorted.map((it) => {
    const normalizeAccion = (raw) => {
      const lower = String(raw ?? "").trim().toLowerCase();
      return lower === "ingreso" ? "ingresada" : lower;
    };
    const capitalizeWords = (raw) => {
      return String(raw ?? "")
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    };
    const capitalizeFirst = (raw) => {
      const s = String(raw ?? "").trim();
      if (!s) return s;
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    const accion = normalizeAccion(it?.ACCION);
    const sector = it?.SECTOR;
    const usuarioRaw = String(it?.USUARIO ?? "").trim();
    const usuario = usuarioRaw.toLowerCase() === "job_mail" ? "Cuentas a Pagar" : usuarioRaw;
    const fecha = String(it?.FECHA ?? "").trim();
    const title = `Factura ${accion}`;
    const baseDesc = capitalizeFirst(`${sector ? `${sector}` : ""}`.trim());
    const userDesc = `${usuario ? `${usuario}` : ""}`;
    const descriptions = [baseDesc, userDesc, fecha].filter(Boolean);
    return { title, descriptions, status: "completed" };
  });

  return (
    <div>
      {steps.length > 0 && <Stepper steps={steps} />}
    </div>
  );
}

InvoiceHistory.propTypes = {
  idComprobante: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  refreshKey: PropTypes.number
};
